module.exports = __webpack_public_path__ + "static/gh-6-1e70fa95fe9743daa740c7d34993beee.jpg";